<template>
    <base-modal :modal-title="'Edit Field'" @save="save()" @close="close()">
        <FormulateForm>
            <FormulateInput type="text" v-model.trim="fieldModel.name" label="Name" validation="required" />
            <FormulateInput type="select" v-model="fieldModel.data_type" :option-groups="dataTypeOptions" label="Data Type" />
            <FormulateInput type="select" v-model="fieldModel.field_type" :options="fieldTypeOptions" label="Field Type" />
            <template v-if="fieldModel.field_type == 'calculated'">
                <h5><b>Field Value Formula</b></h5>
                <boolean-expression-widget
                    :expression="fieldModel.formula"
                    @updateExpression="updateExpression">
                </boolean-expression-widget>
            </template>
        </FormulateForm>
    </base-modal>
</template>


<script>
// Load the full build. 
  var _ = require('lodash');

 import BaseModal from 'components/modals/BaseModal';
 import BooleanExpressionWidget from 'components/elements/BooleanExpressionWidget';

 export default {
     components: {
         BaseModal,
         BooleanExpressionWidget
     },
     props: {
         field: {
             type: Object,
             default () {
                 return {
                     name: ''
                 };
             }
         },
     },
     data () {
         return {
             dataTypes: [],
             fieldTypeOptions: {
                 "C": "CRM",
                 "L": "Lead",
                 'calculated': 'Calculated Field'
             },
             fieldModel: null
         };
     },
     created () {
         this.fieldModel = _.clone(this.field, true);
         this.fetchDataTypes();
     },
     computed: {
         dataTypeOptions: function () {
             if (this.fieldModel.field_type == 'calculated') {

                 let booleanField = {
                     'id': 'BooleanField',
                     'type': 'basic',
                     'name': 'Boolean'
                 };

                 this.fieldModel.data_type = booleanField;

                 return {
                     'Basic Types': [
                         {
                             value: booleanField,
                             label: booleanField.name,
                             id: booleanField.id
                         }
                     ]
                 };
             }
             else {
                 let res = {
                     'Basic Types': [],
                     'Custom Types': []
                 }

                 this.dataTypes.forEach(function (item) {
                     var key = item.type == 'basic' ? 'Basic Types' : 'Custom Types';
                     res[key].push({
                         value: item,
                         label: item.name,
                         id: item.id
                     });
                 });

                 return res;
             }
         }
     },
     methods: {
         fetchDataTypes () {
             var self = this;
             API.dataTypes.getList()
                .then(function (response) {
                    self.dataTypes = response.data;
                });
         },
         close() {
             this.$emit('close');
         },
         updateExpression(updatedExpression) {
             this.fieldModel.formula = null;
             this.$set(this.fieldModel, 'formula', updatedExpression);
         },
         save() {
             var requestData = {};

             // ID
             if (this.fieldModel.id) {
                 requestData.id = this.fieldModel.id;
             }
             // Name
             if (this.fieldModel.name) {
                 requestData.name = this.fieldModel.name;
             }
             // Data type
             if (this.fieldModel.data_type) {
                 requestData.data_type = this.fieldModel.data_type;
             }
             // Field type
             if (this.fieldModel.field_type) {
                 requestData.field_type = this.fieldModel.field_type;
             }

             if (this.fieldModel.field_type == 'calculated') {
                 requestData.formula = this.fieldModel.formula;
             }

             if (requestData.name) {
                 var self = this;
                 API.fields.save(requestData)
                    .then(function (response) {
                        // closing modal
                        self.$emit('close', true);
                    });
             }
         }
     }
}
</script>


<style>
</style>



// WEBPACK FOOTER //
// FieldModal.vue?6c0e65a0